import { render } from "./ShowMiscel.vue?vue&type=template&id=7f36f14c&scoped=true"
import script from "./ShowMiscel.vue?vue&type=script&lang=js"
export * from "./ShowMiscel.vue?vue&type=script&lang=js"

import "./ShowMiscel.vue?vue&type=style&index=0&id=7f36f14c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f36f14c"

export default script